import { Route, Routes } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import { useEffect } from "react";
import Url from "../../../apiCall/UrlConfig";
import { message } from "antd";
import SegmentCariesMainPage from "./SegmentCariesMainPage";
import Analyses from "./Analyses";
import ListAnalyses from "./ListAnalyses";

const RouterSegmentCariesTeeth = (props) => {
  useEffect(() => {
    _getUserInfo();
  }, []);

  const _getUserInfo = async () => {
    let url = Url.getuserIfSegmentCaries;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {});

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };

  let userObj = props.coreData[Url.getuserIfSegmentCaries]?.[Url.action]?.data;

  return (
    <div>
      {userObj?.examPassed && (
        <Routes>
          <Route path="/main/analyses/:imageId" element={<Analyses />} />
          <Route path="/main/youranalyses" element={<ListAnalyses />} />

          <Route path="/main" element={<SegmentCariesMainPage />} />
        </Routes>
      )}

      {userObj?.examPassed === false && (
        <>
          <div>You Dont Have Enough Permission</div>
        </>
      )}
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RouterSegmentCariesTeeth);
